import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { QuotationListPage } from './QuotationListPage';
import { QuotationCreatePage } from './QuotationCreatePage';
import { QuotationDetailPage } from './QuotationDetailPage';

export const quotationRoutes: RouteObject[] = [
  { path: paths.quotations, element: <QuotationListPage /> },
  { path: paths.quotationCreate, element: <QuotationCreatePage /> },
  { path: paths.quotationDetail, element: <QuotationDetailPage /> }
];
